import Storage from "./storage.service";
import Settings from "./settings";

import SendBird from "sendbird";
import SendBirdDesk from "sendbird-desk";
import Events from "./events.service";

var Chats = {};

var sb;
var ApplicationUserListQuery;

let prefix = "Web-";

const Ticket = SendBirdDesk.Ticket;

Chats.init = () => {
	if (sb) {
		return sb;
	}
	sb = new SendBird({
		appId: Settings.sendbird_app_id
	});

	Chats.connectHandler();

	return sb;
};

Chats.activateOpenTicket = () => {
	let ticket = Storage.get("ticket");
	if (Settings.debug_bird)
		console.log("Chats.activateOpenTicket .. tivcket: ", ticket);
	if (ticket) {
		Storage.set("active_ticket", ticket);
		if (Settings.debug_bird) console.log("set ticket:", ticket);
	} else {
		if (Settings.debug_bird) console.log("unhandled errr: no ticket");
	}
};

Chats.clearTicket = () => {
	Storage.clear("active_ticket");
	Storage.clear("ticket"); // ?
	Storage.clear("ticket_messages");
};

Chats.clearTicketAndOpenNew = () => {
	Storage.set("ticket_is_closed", false);
	Chats.clearTicket();
	return Chats.addTicket();
};

Chats.confirmResolveInquiry = (message, confirmYN) => {
	if (Settings.debug_bird)
		console.log("Chats.confirmResolveInquiry " + confirmYN);
	Ticket.confirmEndOfChat(message, confirmYN, (res, err) => {
		let count = Storage.get("ticket_inquiry_count") || 0;
		Storage.set("ticket_inquiry_count", count + 1);
	});
};

Chats.checkForResolveInquiry = message => {
	// if(Settings.debug_bird) console.log(message);

	let result = "";

	if (message.data) {
		let data = JSON.parse(message.data);
		// let data = message.data;

		// if(Settings.debug_bird) console.log(data);

		let isClosureInquired =
			data.type === SendBirdDesk.Message.DataType.TICKET_INQUIRE_CLOSURE;

		// types
		//"TICKET_ASSIGN"
		//"NOTIFICATION_WELCOME"
		//"TICKET_TRANSFER"

		if (isClosureInquired) {
			let closureInquiry = data.body;

			switch (closureInquiry.state) {
				case SendBirdDesk.Message.ClosureState.WAITING:
					// do something on WAITING
					result = "WAITING";
					break;
				case SendBirdDesk.Message.ClosureState.CONFIRMED:
					result = "CONFIRMED";
					// Chats.retrieveTicket();
					// Chats.retrieveClosedTickets();
					// do something on CONFIRMED
					break;
				case SendBirdDesk.Message.ClosureState.DECLINED:
					result = "DECLINED";
					// Chats.retrieveTicket();
					// Chats.retrieveClosedTickets();
					// do something on DECLIND
					break;

				default:
					// do something on DECLIND
					break;
			}
		} else {
			if (data.type === "NOTIFICATION_MANUAL_CLOSED") {
				result = "CLOSED";
				// let old = Storage.get("active_ticket");
				// old.status = "CLOSED";
				// Storage.set("active_ticket", old);
				// Chats.retrieveTicket();
				// Chats.retrieveClosedTickets();
			}
		}
	}

	return result;
};

Chats.connectHandler = () => {
	var ChannelHandler = new sb.ChannelHandler();

	ChannelHandler.onMessageReceived = function(channel, message) {
		Chats.loadMessages(channel);
		// if(Settings.debug_bird) console.log(channel);
		// if(Settings.debug_bird) console.log(message);

		Chats.checkForResolveInquiry(message);
	};

	ChannelHandler.onMessageUpdated = (channel, message) => {
		SendBirdDesk.Ticket.getByChannelUrl(channel.url, (ticket, err) => {
			if (err) throw err;
			Chats.checkForResolveInquiry(message);
		});
	};

	// handler.onTypingUpdate(channel);
	// handler.onReadReceiptUpdate(channel);

	sb.addChannelHandler("UNIQUE_HANDLER_ID", ChannelHandler);
};

Chats.loadMessages = channel => {
	var prevMessageListQuery = channel.createPreviousMessageListQuery();
	prevMessageListQuery.limit = 100;
	prevMessageListQuery.reverse = true;

	prevMessageListQuery.load(function(messages, error) {
		if (error) {
			return;
		}

		if (Settings.debug_bird)
			console.log("set ticket_messages", messages.reverse());

		Storage.set("ticket_messages", messages ? messages.reverse() : []);
	});
};

Chats.connectUser = uid => {
	let identi = uid + "@virginmobile.ae";
	sb.connect(identi, function(user, error) {
		if (error) {
			return;
		}

		Chats.clearTicket();

		let after = () => {

			SendBirdDesk.init(SendBird);

			// User ID: Account ID@virginmobile.ae (if user is logged in) otherwise it’s session ID@virginmobile.ae

			SendBirdDesk.authenticate(identi, (res, err) => {
				// Fi res.data.token

				if (err) {
					return;
				}

				if (Settings.debug_bird) console.log("bird_connected");
				// Now you can use Desk SDK later on
				Storage.set("bird_connected", true);
			});
		};

		Chats.setUserData(after);
	});
};

Chats.retrieveClosedTickets = userName => {
	return new Promise((resolve, reject) => {
		Ticket.getClosedList(0, (res, err) => {
			if (res && res.length) {
				Storage.set("closed_tickets", res);
				resolve(res);
			}
			if (err) {
				// @Todo handle error
				Storage.set("closed_tickets", null);
				reject(err);
			}
		});
	});
};

Chats.addTicket = () => {
	let f = Chats.createTicket();

	if (Settings.debug_bird) console.log("addTicket");

	f
		.then(res => {
			if (Settings.debug_bird) console.log("added Ticket", res);
			Storage.set("ticket", res);
		})
		.catch(err => {
			// @Todo handle error
			if (Settings.debug_bird) console.log("added Ticket error", err);
			Storage.set("ticket", null);
		});

	return f;
};

Chats.createTicket = () => {
	var user = sb.currentUser;

	if (Settings.debug_bird) console.log("Chats.createTicket user:", user);
	return new Promise((resolve, reject) => {
		Ticket.create("#" + prefix + Date.now(), user.nickname, (ticket, err) => {
			if (Settings.debug_bird)
				console.log("Chats.createTicket Promise ticket:", ticket);
			if (Settings.debug_bird)
				console.log("Chats.createTicket Promise err:", err);

			if (ticket) {
				Events.when_user_interacts_with_sendBird('agent_chat_started');
				resolve(ticket);
			} else {
				resolve(null);
			}
			if (err) {
				// @Todo handle error
				reject(err);
			}
		});
	});
};

Chats.getOrCreateTicket = (ticketTitle, userName) => {
	Chats.retrieveTicket()
		.then(res => {
			let ticket = res;
			if (res) {
				Storage.set("ticket", ticket);
			} else {
				Chats.addTicket();
			}
		})
		.catch(err => {
			// @Todo handle error
			Storage.set("ticket", null);
		});
};

Chats.getTicket = () => {
	Chats.retrieveTicket()
		.then(res => {
			Storage.set("ticket", res);
		})
		.catch(err => {
			// @Todo handle error
			Storage.set("ticket", null);
		});
};

Chats.retrieveTicket = (ticketTitle, userName) => {
	return new Promise((resolve, reject) => {
		Ticket.getOpenedList(0, (res, err) => {
			if (err) {
				// @Todo handle error
				reject(err);
			}
			if (res && res.length) {
				resolve(res[0]);
			} else {
				resolve(null);
			}
		});
	});
};

Chats.refreshChannel = channel => {
	channel.refresh(function(response, error) {
		if (error) {
			return;
		}
	});
};

Chats.sendMessage = (ticket, message, type = "UserMessage", data = null) => {
	if (Settings.debug_bird) console.log("Chats.sendMessage : ", message);

	let params = new sb.UserMessageParams();

	params.message = message;
	params.customType = type;

	params.data = data;

	ticket.channel.sendUserMessage(params, function(message, error) {
		if (Settings.debug_bird)
			console.log("ticket.channel.sendUserMessage : ", message);
		if (error) {
			return;
		}
		Chats.loadMessages(ticket.channel);
	});
};

Chats.disconnectUser = uid => {};

Chats.getAppUsers = () => {
	return sb.createApplicationUserListQuery();
};

Chats.checkIfUserIsOnline = uid => {
	// var sb = SendBird.getInstance();

	// returns all users across app
	ApplicationUserListQuery = Chats.getAppUsers();

	// ApplicationUserListQuery.userIdsFilter = [uid];
	ApplicationUserListQuery.next(function(users, error) {
		if (error) {
			return;
		}

		if (users[0].connectionStatus === sb.User.ONLINE) {
			// User.connectionStatus consists of NON_AVAILABLE, ONLINE, and OFFLINE.
		}
	});
};

// ticket title = # + timestamp
// Username = Account ID (if user is logged in) otherwise it’s Anonymous
// User ID: Account ID@virginmobile.ae (if user is logged in) otherwise it’s session ID@virginmobile.ae

Chats.setUserData = after => {
	let nickname = "Anonymous";
	let profile_url = "";
	let account_id = Storage.get("account_id");
	if (account_id) {
		nickname = account_id + "@virginmobile.ae";
	}

	// nickname = prefix + nickname;

	sb.updateCurrentUserInfo(nickname, profile_url, function(res, error) {
		if(after){
			after();
		}
		// if (error) {
		// 	return;
		// }
	});
};

export default Chats;